/**
 * Ícones do "Menu-ia" (Figma 6051:2746), desenhados no grid de 20px do Workbase:
 * lápis de "Nova conversa", sidebar-open (recolher/abrir o histórico — o DS não
 * tem ícone de relógio) e "···" do menu do item. Largura/altura vão no `style`
 * por causa da regra global `svg { width: 100% }` injetada por terceiros.
 */
type HistoryIconProps = {
  color?: string;
  size?: number;
};

/** outline/action/edit */
export function HistoryEditIcon({
  color = "currentColor",
  size = 20,
}: HistoryIconProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size, display: "block", flexShrink: 0 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6034 2.23991C12.0602 2.06352 12.5195 2.05289 12.9389 2.12842C13.6411 2.255 14.295 2.63573 14.8082 2.99431L15.0198 3.14567L15.2273 3.30192C15.7223 3.68518 16.2802 4.19663 16.6099 4.82943C16.8067 5.20726 16.9337 5.64875 16.9013 6.13721C16.8686 6.6274 16.68 7.1001 16.3528 7.54509C16.3498 7.54917 16.3461 7.55411 16.343 7.55811L9.55099 16.444L9.55018 16.4432C9.11499 17.0279 8.46635 17.4171 7.74517 17.5239L5.19715 17.9007C4.39686 18.0192 3.65084 17.4701 3.5256 16.6711L3.12765 14.1263C3.01414 13.4008 3.19466 12.6597 3.62976 12.0682L3.63953 12.056L10.4315 3.17009C10.7572 2.73138 11.1492 2.41535 11.6034 2.23991ZM4.97254 13.0562L4.91313 13.1465C4.78496 13.3629 4.73476 13.6185 4.77397 13.8692L5.14181 16.2235L7.50102 15.8752C7.78784 15.8327 8.04626 15.6772 8.21799 15.4439L8.22694 15.4317L13.3449 8.73324L10.0995 6.34799L4.97254 13.0562ZM12.6434 3.76823C12.4608 3.73534 12.3205 3.74933 12.204 3.79427C12.0892 3.83862 11.9364 3.93668 11.7645 4.17025C11.7616 4.17426 11.7586 4.17851 11.7556 4.18246L11.1119 5.02393L14.3573 7.40919L15.0116 6.55388C15.1813 6.32219 15.2297 6.14877 15.2378 6.02653C15.2461 5.90199 15.2177 5.76377 15.1321 5.59929C14.9436 5.23753 14.5412 4.86247 14.0318 4.48763C13.5224 4.11288 13.0449 3.84063 12.6434 3.76823Z"
        fill={color}
      />
    </svg>
  );
}

/** sidebar-open */
export function HistorySidebarOpenIcon({
  color = "currentColor",
  size = 20,
}: HistoryIconProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size, display: "block", flexShrink: 0 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5148 1.66667C14.9491 1.66667 16.1752 2.17878 17.0386 3.10629C17.8957 4.02705 18.3333 5.28951 18.3333 6.68864V13.3114C18.3333 14.7115 17.8931 15.9743 17.0353 16.8945C16.1715 17.8211 14.9459 18.3333 13.5148 18.3333H6.48601C5.05176 18.3333 3.825 17.8212 2.96143 16.8937C2.1043 15.973 1.66668 14.7105 1.66667 13.3114V6.68864C1.66667 5.28938 2.10478 4.02703 2.96224 3.10629C3.82595 2.17885 5.05224 1.66667 6.48682 1.66667H13.5148ZM6.48682 3.33334C5.46385 3.33334 4.6966 3.68826 4.18132 4.24154C3.6598 4.80154 3.33334 5.6336 3.33334 6.68864V13.3114C3.33334 14.3664 3.65987 15.1985 4.18132 15.7585C4.69653 16.3118 5.46353 16.6667 6.48601 16.6667H12.0483V3.33334H6.48682ZM13.715 16.661C14.6342 16.6175 15.3343 16.2747 15.8162 15.7577C16.3387 15.1972 16.6667 14.3655 16.6667 13.3114V6.68864C16.6667 5.63348 16.34 4.80152 15.8187 4.24154C15.3379 3.72509 14.6379 3.38076 13.715 3.33741V16.661ZM6.34929 7.26482C6.66248 6.92781 7.18968 6.90861 7.52686 7.22168L9.86329 9.39128C10.0331 9.54893 10.1294 9.76995 10.1294 10.0016C10.1294 10.2334 10.0331 10.4551 9.86329 10.6128L7.52686 12.7824C7.18963 13.0955 6.66246 13.0756 6.34929 12.7384C6.03617 12.4012 6.05528 11.8741 6.39242 11.5609L8.07129 10.0016L6.39242 8.44239C6.05541 8.1292 6.03622 7.602 6.34929 7.26482Z"
        fill={color}
      />
    </svg>
  );
}

/** outline/action/menu-overflow (···) */
export function HistoryMoreIcon({
  color = "currentColor",
  size = 20,
}: HistoryIconProps) {
  return (
    <svg
      aria-hidden
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: size, height: size, display: "block", flexShrink: 0 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16667 8.33333C5.0869 8.33333 5.83333 9.07976 5.83333 10C5.83333 10.9202 5.0869 11.6667 4.16667 11.6667C3.24643 11.6667 2.5 10.9202 2.5 10C2.5 9.07976 3.24643 8.33333 4.16667 8.33333Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.33333C10.9202 8.33333 11.6667 9.07976 11.6667 10C11.6667 10.9202 10.9202 11.6667 10 11.6667C9.07976 11.6667 8.33333 10.9202 8.33333 10C8.33333 9.07976 9.07976 8.33333 10 8.33333Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8333 8.33333C16.7536 8.33333 17.5 9.07976 17.5 10C17.5 10.9202 16.7536 11.6667 15.8333 11.6667C14.9131 11.6667 14.1667 10.9202 14.1667 10C14.1667 9.07976 14.9131 8.33333 15.8333 8.33333Z"
        fill={color}
      />
    </svg>
  );
}
